import { render, staticRenderFns } from "./togglable-div.vue?vue&type=template&id=4179c78a&scoped=true&lang=pug"
import script from "./togglable-div.vue?vue&type=script&lang=js"
export * from "./togglable-div.vue?vue&type=script&lang=js"
import style0 from "./togglable-div.vue?vue&type=style&index=0&id=4179c78a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4179c78a",
  null
  
)

export default component.exports